import { classNames } from 'primereact/utils';
import React, { useContext, useEffect, useRef, useState } from 'react';
import AppTopbar from './header';
import { Outlet } from 'react-router-dom';
import AppSidebar from './sidebar';
import { useAuthUser } from '../../auth/AuthService';
import { LayoutContext } from './layoutcontext';
import Banner from '../../Components/PrimeReact/banner';
import AppFooter from './footer';
import { useEventListener } from 'primereact/hooks';
import { useTranslation } from 'react-i18next';

const AdminLayout = () => {
    const authUser = useAuthUser();
    (authUser()?.role === 'admin' || authUser()?.role === 'manager') && import('../../Styles/admin.css');
    const {t, i18n} = useTranslation();
    const sidebarRef = useRef(null);
    const topbarRef = useRef(null);
    const { sidebarToggle,  menuTitle, setSidebarToggle } = useContext(LayoutContext);
    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    const blockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

    const [bindMenuOutsideClickListener, unbindMenuOutsideClickListener] = useEventListener({
        type: 'click',
        listener: (event) => {
            const isOutsideClicked = !(
                sidebarRef.current?.isSameNode(event.target) ||
                sidebarRef.current?.contains(event.target) ||
                topbarRef.current?.menubutton?.isSameNode(event.target) ||
                topbarRef.current?.menubutton?.contains(event.target)
            );

            if (isOutsideClicked) {
                hideMenu();
            }
        }
    });

    const hideMenu = () => {
        setSidebarToggle(false)
        unbindMenuOutsideClickListener()
        unblockBodyScroll();
    };

    useEffect(() => {
        if (sidebarToggle && !isDesktop()) {
            blockBodyScroll()
            bindMenuOutsideClickListener()
        }
    }, [sidebarToggle])

    const containerClass =  classNames('layout-wrapper layout-theme-light layout-static p-ripple-disabled');
    const containerClassHide = isDesktop() ? classNames('layout-wrapper layout-theme-light layout-static layout-static-inactive p-ripple-disabled') : 'layout-wrapper layout-theme-light layout-static layout-mobile-active p-ripple-disabled';

    return (
        <React.Fragment>
            <div className={(!sidebarToggle ? containerClass : containerClassHide) + ' admin-body-color'}>
                <AppTopbar ref={topbarRef}/>
                <div ref={sidebarRef} className="layout-sidebar">
                    <AppSidebar />
                </div>
                <div className="layout-main-container">
                    <div className="layout-main">
                        <div className="grid crud-demo">
                            <div className="col-12">
                                <div className="card">
                                    <div className='grid -mt-5'>
                                        <div className='col-12 md:col-4 flex align-items-center'>
                                            <span className='text-800 text-xl md:text-4xl font-bold pt-2'>{t(menuTitle)}</span>
                                        </div>
                                        <Banner />
                                    </div>
                                    <Outlet/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <AppFooter />
                    <div className="layout-mask"></div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AdminLayout;
